<template>
    <div :class="sModoCampo=='2'?'radioButtonSegundaVersion':''">
        <span :class="['span-titulo font-weight-medium']" style="color: #0056D3;font-size: medium;">{{ sLabel }}</span>
        <span v-if="bObligatorio" class="span-titulo font-weight-bold ml-1 red--text">*</span>
        <!-- <IconoInformacion :sInformativo="sInfoAyuda" /> -->
        <div class="d-flex mt-3" style="width: 100%;">
            <v-radio-group
                style="width: 100%;"
                class="ma-0"
                v-model="valor"
                v-bind="oAtributos"
                :disabled="bEditable"
                @change="onRadioChange"
                :rules="noVacio"
            >
                <v-radio
                    class="radioButonParticular"
                    :class="{ bErrorClass: bError }"
                    v-for="(opcion, index) in onOpcionesCondicion"
                    :key="index"
                    :label="opcion.label"
                    :value="opcion.value"
                >
                <template v-slot:label>
                    <div class="black--text">{{opcion.label}}</div>
                </template>
                </v-radio>
            </v-radio-group>
        </div>
        <div class="text-center">
            <v-dialog v-model="bModalCambio"width="500" >
                <v-card>
                    <v-card-title class="text-h5 lighten-2 d-flex align-center">
                        <v-col cols="2">
                            <v-icon color="warning" class="mr-2">mdi-alert-outline</v-icon>
                        </v-col>
                        <v-col cols="10" class="no-word-break">
                            Cambiar estado del elemento
                        </v-col>
                    </v-card-title>

                    <v-card-text>
                        <v-col cols="12" class="no-word-break">
                            Si ya ingresaste información en el formulario, se perderá al cambiar el estado del elemento. ¿Deseas continuar?
                        </v-col>
                    </v-card-text>
                    <v-card-actions class="justify-end py-5">
                        <v-btn
                            color="gray"
                            class="mr-3"
                            @click="cancelarCambio"
                        >
                            Cancelar
                        </v-btn>

                        <v-btn
                            color="primary"
                            @click="confirmarCambio(null)"
                        >
                            Sí, cambiar estado
                        </v-btn>
                        </v-card-actions>

                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
let valorViejo = null;
import { mapGetters } from 'vuex'
// import IconoInformacion from '@/components/Form/Componentes/subComponentes/IconoInformacion.vue'
export default {
    name: 'FormRadioButton',
    components: {
    },
    props: {
        aOpciones: {
            type: Array,
            required: true,
            default: () => []
            // Formato: [{ label: 'Texto que se muestra', value: 'valor_a_enviar' }]
        },
        value: {
        },
        oAtributos:{
            type:Object,
            default:()=>{}
        },
        bObligatorio:{
            type: Boolean,
            default: false,
        },
        sLabel:{
            type: String,
            default: "",
        },
        sModoCampo:{
            type: String,
            default: "1",
        },
        sCampoModificaA:{
            type: String,
            default: "",
        },
        sGrupo:{
            type: String,
            default: "",
        },
        bError:{
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            valor: this.value,
            esError: false,
            noVacio: [v => !!v || 'Este campo es obligatorio'],
            bEditable: this.editable === '0',
            bModalCambio:false,
            valorPendiente:null
        }
    },
    watch: {
        // valor(nuevo) {
        //     //Validamos que si es el tipo campo 2 hacemos una validacion
        //     if(this.sModoCampo=="2"){
        //         this.bModalCambio = true;
        //     }
        //     else{
        //         this.$emit('input', nuevo)
        //         this.$emit('modificaA',{sCampoModificaA:this.sCampoModificaA,nId:nuevo})
        //     }
        // },
        valor(nuevo,viejo) {
            nuevo
            valorViejo = viejo;
        }
    },
    computed: {
        ...mapGetters(['getoFormError']),
        onOpcionesCondicion(){
            //Vallidamos si tiene condiciones
            let aOpcionesTemp = [];
            this.aOpciones.forEach(oOpcion => {
                let bMostrar = false;
                if(oOpcion?.condicion){
                    let aFiltro = oOpcion?.condicion?.split(";")
                    if(aFiltro[0]=="idPerfil"){
                        //Obtenemos los ids de los perfiles
                        let aPerfiles = aFiltro[1]?.split(",")
                        if(aPerfiles?.includes(this.$store.state.nIdPerfil?.toString())){
                            bMostrar= true;
                        }
                    }
                }
                else{
                    bMostrar = true;
                }

                if(bMostrar){
                    aOpcionesTemp.push(oOpcion);
                }
            });
            return aOpcionesTemp;
        }
    },
    methods: {
        onRadioChange(nuevo) {
            const bPrimeraCarga = this.value !== null && this.value !== undefined;

            // Si ya había un valor, pedimos confirmación
            if (this.sModoCampo === "2" && bPrimeraCarga) {
                this.valorPendiente = nuevo;
                this.bModalCambio = true;
                return;
            }

            // Primera vez → cambio directo
            this.confirmarCambio(nuevo);
        },

        confirmarCambio(valor) {
            let valorTemp = valor;
            if(valorTemp==null){
                valorTemp = this.valorPendiente
            }
            this.$emit('input', valorTemp);
            this.$emit('modificaA', {
            sCampoModificaA: this.sCampoModificaA,
            nId: valorTemp
            });

            this.valorPendiente = null;
            this.bModalCambio = false;
        },

        cancelarCambio() {
            // devolvemos el radio al valor confirmado
            this.valor = valorViejo;

            this.valorPendiente = null;
            this.bModalCambio = false;
        }

    }
}
</script>
<style scoped>
.radioButonParticular{
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 8px 12px;
    margin-bottom: 8px;
    color: #1E2939;
}
.bErrorClass {
  border-color: red;
}
.radioButtonSegundaVersion .radioButonParticular.v-item--active{
  border-color: #0d47a1; /* azul oscuro */
  background-color: rgba(13, 71, 161, 0.06);
}
.radioButtonSegundaVersion{
    margin-top: 14px;
    border-radius: 10px;
    padding: 8px 12px;
    margin-bottom: 8px;
    background: linear-gradient(135deg, rgba(0, 86, 211, 0.05) 0%, rgba(239, 246, 255, 0.3) 100%);
    border: 1.26px solid #0056D333;
}
.no-word-break {
  word-break: normal;
  overflow-wrap: normal;
  white-space: normal;
}
</style>